import { useTranslation } from 'next-i18next';
import React, { FC, useMemo } from 'react';
import { formatedDate, formatNumericValue } from 'utils/general';

import { CardColumn } from '@/modules/Settlements/components/Details/shared/CardColumn';
import { ISettlements } from '@/modules/Settlements/types';
import { Typography } from '@/shared/components/atoms';
import { formatAccountingPeriod } from '@/shared/components/molecules/CreateSettlement/logic';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Time from '~/images/shared/ic-time.svg';
import Time2 from '~/images/shared/ic-time2.svg';
import User2 from '~/images/shared/ic-user 2.svg';
import User from '~/images/shared/ic-user.svg';

interface Props {
  data?: Partial<ISettlements.IWorkerSettlementSchema>;
}

const TopBanner: FC<Props> = ({ data }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);

  const issuanceOrCreationDate = useMemo(
    () => ({
      key: data?.status === 1 ? 'creation-Date' : 'issuing-date',
      value:
        data?.status === 1
          ? data?.creationDate || '-'
          : data?.issuanceDate || '-',
    }),
    [data?.creationDate, data?.issuanceDate, data?.status]
  );

  return (
    <div className='scrollbar-rounded-lg flex w-full items-center justify-between gap-2 overflow-x-auto whitespace-nowrap rounded-2xl border-xs border-neutralVariant-90 bg-background-neutral-99 px-16 py-24 overflow-y-hidden scrollbar-thin  scrollbar-thumb-background-400 scrollbar-h-1'>
      {data?.workerName ? (
        //  worker
        <CardColumn
          label={t('worker')}
          value={data?.workerName}
          icon={<User />}
        />
      ) : (
        ''
      )}
      {/* team leader */}
      <CardColumn label={t('Crew')} value={data?.crewName} icon={<User />} />

      {/* issuanceDate */}
      <CardColumn
        label={t(issuanceOrCreationDate.key)}
        value={`${formatedDate(
          issuanceOrCreationDate.value,
          'd MMMM yyyy',
          language
        )}`}
        icon={<Time />}
      />

      {/* created-by */}
      <CardColumn
        label={t('created-by')}
        value={data?.issuedBy ?? data?.createdBy}
        icon={<User2 />}
      />

      {/* accounting-period */}
      <CardColumn
        label={t('accounting-period')}
        value={formatAccountingPeriod({
          language,
          startDate: data?.startDate,
          endDate: data?.endDate,
        })}
        icon={<Time2 />}
      />

      {/* total-settlement */}
      <div className='rounded-xl bg-outline-default px-16 py-2 text-center'>
        <Typography className='text-primary-default'>
          {t('total-settlement')}
        </Typography>
        <Typography className='text-primary-default' weight='bold'>
          {data?.totalAmount ? formatNumericValue(data.totalAmount) : '-'}{' '}
          {selectedAsset?.currency}
        </Typography>
      </div>
    </div>
    // </div>
  );
};
export { TopBanner };
